import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
    classDetails: {},
    resgistrationForm: [],
    products: [],
    varients: {},
    numberOfTickets: [],
    bulkClassDetails: {},
    bulkRegistrationForm: [],
    bulkNumberOfTickets: [],
    bulkTicketTypeList: [],
    selectedValue: [],
}

export const Class = createSlice({
    name: "class",
    initialState,
    reducers: {
        resetAction: (state) => {
            return {...state,selectedValue:[],FormDataReservation:[]};
        },
        setClassDetails: (state, action) => {
            state.classDetails = action.payload;
            return state;
        },
        setRegistartionDetails: (state, action) => {
            state.resgistrationForm = action.payload;
            return state;
        },
        setCounterTicket: (state, action) => {
            state.numberOfTickets = action.payload;
            return state;
        },
        setTotalProducts: (state, { payload }) => {
            return { ...state, totalProducts: payload };
        },
        setProducts: (state, { payload }) => {
            console.log('payload state', payload)
            return { ...state, products: payload };

        },
        setVarients: (state, action) => {
            return { ...state, varients: action.payload };
        },
        setBulkClassDetails: (state, action) => {
            state.bulkClassDetails = action.payload;
            return state;
        },
        setBulkRegistrationDetails: (state, action) => {
            state.bulkRegistrationForm = action.payload;
            return state;
        },
        setBulkCounterTicket: (state, action) => {
            state.bulkNumberOfTickets = action.payload;
            return state;
        },
        setBulkTicketTypeList: (state, payload) => {
            state.bulkTicketTypeList = payload.payload;
            return state;
        },
        setSelectedValue: (state, action) => {
            const { data, productIndex, productTitle, dropdownIndex, type, ticketIndex } = action.payload
            state.selectedValue = data;
            // find the object depends on dropdownIndex and ticketIndex we need it to change on varients counter value depends on productIndex
            const selectedValueIndex = state.selectedValue?.map((item) => {
                return item[productTitle]?.find((item) => item.indexSelected === dropdownIndex && item.ticketIndex === ticketIndex)
            })
            const changeQuantity = data && state?.varients?.[productIndex]?.variantsInfo?.map((varient) => {
                console.log('QWQWQWQvarient', varient)
                // check if the object value  is equal to the option one and update counterValue 
                if (varient.option === selectedValueIndex[0]?.value && type !== 'remove') {
                    return { ...varient, counterValue: varient?.counterValue + 1 };
                    // minas from counterValue if the type is remove (came from ticket inside decrement button) if the user remove one of the dropdowns
                } else if (varient.option === selectedValueIndex[0]?.value && type === 'remove') {
                    return { ...varient, counterValue: varient?.counterValue - 1 };
                }
                // if we have previousValue inside selectedValueIndex object 
                else if (selectedValueIndex[0]?.previousValue) {
                    // check if this previousValue  is same as Varient Option then mines counterValue value from array from object
                    if (selectedValueIndex[0]?.previousValue === varient?.option) {
                        return { ...varient, counterValue: varient?.counterValue > 0 ? varient?.counterValue - 1 : varient?.counterValue };
                    } else {
                        return { ...varient };
                    }
                    // if we have no match just return the item as it is
                } else {
                    return { ...varient };
                }
            }
            )
            // Replace the product with new array of products after adding/removing a variant
            const replaceOldData = { ...state?.varients, [productIndex]: { ...state.varients?.[productIndex], variantsInfo: changeQuantity } }
            state.varients = replaceOldData;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(REHYDRATE, (state, action) => {
            if (action.key === 'root' && action.payload?.Class) {
                const rehydratedClass = action.payload.Class;
                return {
                    ...state,
                    ...rehydratedClass,
                    varients: initialState.varients,
                    selectedValue: initialState.selectedValue,
                    totalProducts: 0,
                    products: (rehydratedClass.products || []).map(p => ({
                        ...p,
                        counter: 0,
                        dropdowns: [],
                    })),
                };
            }
            return state;
        });
    },
});

export const { setClassDetails, setCounterTicket, setBulkClassDetails, setBulkCounterTicket, setBulkRegistrationDetails, setBulkTicketTypeList, } = Class.actions;

export default Class.reducer;
